import { Add } from "../../components/Add";

import { useState } from "react";
import styles from "../../../styles/banners.module.scss";
import { Icon } from "../../components/core/Icon";
import BannersForm from "./BannersForm";
import BannersSort from "./BannersSort";

const BannersTotem = ({ banners, openSort, onCloseSort, onRefresh }) => {
  const [visible, setVisible] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);

  return (
    <div className={styles.totem}>
      <div className={styles.header}>
        Vertical ({banners?.mobile?.length || 0})
      </div>
      <div className={styles.desktop}>
        {banners?.mobile?.map((banner, index) => {
          return (
            <div className={styles.banner} key={index}>
              <div className={styles.image}>
                <img
                  src={`${process.env.REACT_APP_ASSETS_URL}/${banner?.image}`}
                  alt={banner.name}
                />

                <div
                  className={styles.edit}
                  onClick={() => {
                    setSelectedBanner(banner);
                    setSelectedDevice("mobile");
                    setVisible(true);
                  }}
                >
                  <Icon name="pen" size="lg" light color="#fff" />
                </div>
              </div>
              <div className={styles.details}>
                <p className={styles.name}>{banner?.name}</p>

                <div className={styles.icons}>
                  {banner?.link && <Icon name="link" light size="1x" />}
                  {banner?.visibility && <Icon name="calendar-day" light size="1x" />}
                </div>
              </div>
            </div>
          );
        })}
        <Add
          text="Adicionar banners"
          style={{ height: 550 }}
          className="flex-column"
          onClick={() => {
            setSelectedDevice("mobile");
            setVisible(true);
          }}
        />
      </div>
      <div className={styles.header}>
        Horizontal ({banners?.desktop?.length || 0})
      </div>
      <div className={styles.mobile}>
        {banners?.desktop?.map((banner, index) => {
          return (
            <div className={styles.banner} key={index}>
              <div className={styles.image}>
                <img
                  src={`${process.env.REACT_APP_ASSETS_URL}/${banner?.image}`}
                  alt={banner.name}
                />

                <div
                  className={styles.edit}
                  onClick={() => {
                    setSelectedBanner(banner);
                    setSelectedDevice("desktop");
                    setVisible(true);
                  }}
                >
                  <Icon name="pen" size="lg" light color="#fff" />
                </div>
              </div>
              <div className={styles.details}>
                <p className={styles.name}>{banner?.name}</p>

                <div className={styles.icons}>
                  {banner?.link && <Icon name="link" light size="1x" />}
                  {banner?.visibility && <Icon name="calendar-day" light size="1x" />}
                </div>
              </div>
            </div>
          );
        })}
        <Add
          text="Adicionar banners"
          style={{ height: 400 }}
          className="flex-column"
          onClick={() => {
            setSelectedDevice("desktop");
            setVisible(true);
          }}
        />
      </div>

      <BannersForm
        banners={banners}
        visible={visible}
        onClose={() => {
          setVisible(false)
          setSelectedBanner(null)
        }}
        onSave={() => onRefresh()}
        onDelete={() => {
          setVisible(false);
          setSelectedBanner(null);
          onRefresh();
        }}
        selectedBanner={selectedBanner}
        category={'totem'}
        device={selectedDevice}
        dimensions={{
          desktop: { width: 1920, height: 1080 },
          mobile: { width: 1080, height: 1920 },
        }}
      />

      <BannersSort
        visible={openSort}
        onClose={onCloseSort}
        title="Totem"
        alias={'totem'}
        category={banners}
        devices={[
          { key: "landscape", name: "Paisagem", },
          { key: "portrait", name: "Retrato", },
        ]}
        onSave={() => {
          onRefresh()
          onCloseSort()
        }}
      />
    </div>
  );
};

export default BannersTotem;
